import pako from 'pako';
import { Buffer } from 'buffer';
import request from '../../request';
import {
    PDF_HEADERS,
    PDF_ENCODING_HEADERS,
    PDF_RESPONSE_TYPE,
} from '../../../constants/shared/ApiConstants';

class PdfGeneratorClient {
    static downloadPdfFile = async (url, pdfData) => {
        const compressedData = await pako.gzip(JSON.stringify(pdfData));
        const base64data = Buffer.from(compressedData).toString('base64');
        const contentUrl = await request.post(url, base64data, {
            headers: PDF_ENCODING_HEADERS,
        });
        return request.get(contentUrl, {
            responseType: PDF_RESPONSE_TYPE,
            headers: PDF_HEADERS,
        });
    };
}

export default PdfGeneratorClient;
